import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { Store } from "../utils/storage";

const storage = Store("session");

// Define initial State
const State = {
  connectionError: false,
  satelliteView: false,
  notificationToken: null,
  notificationSubscription: { show: false, type: "" },
};

// Define actions
const Actions = (_set, get) => {
  const set = _set;
  // set connection error
  const setConnectionError = (error) => {
    set({ connectionError: error });
  };

  const toggleSatelliteView = () => {
    set({ satelliteView: !get().satelliteView });
  };
   // Set notification token
  const setNotificationToken = (token) => {
    set({ notificationToken: token });
  };

  // Set notification subscription
  const setNotificationSubscription = ({show, type}) => {
    set({ notificationSubscription: {show, type} });
  };

  return {
    setConnectionError,
    toggleSatelliteView,
    setNotificationToken,
    setNotificationSubscription,
  };
};

// Create Zustand store
const AppSettings = create(
  persist(
    (set, get) => {
      const actions = Actions(set, get);
      return {
        ...State,
        setConnectionError: actions.setConnectionError,
        toggleSatelliteView: actions.toggleSatelliteView,
        setNotificationToken: actions.setNotificationToken,
        setNotificationSubscription: actions.setNotificationSubscription,
      };
    },
    {
      name: "app.global",
      storage: createJSONStorage(() => storage),
    }
  )
);

export default AppSettings;
